import { NETWORK_REQUEST_SENT, PROGRAM_FETCH_COMPLETED, NEW_TERMS_FETCH_COMPLETED } from "./types";
import { buildDefaultHeaders } from "./helper";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { checkAndUpdateToken } from "./auth";

export const getPrograms = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/ooop`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: PROGRAM_FETCH_COMPLETED, programs: data });
    }
  }
}


export const getTerms = (yearId=0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/termlist/${yearId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: NEW_TERMS_FETCH_COMPLETED, terms: data });
    }
  }
}